import { render } from "./Nodi.vue?vue&type=template&id=c24da22e"
import script from "./Nodi.vue?vue&type=script&lang=js"
export * from "./Nodi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__